import ApiService, { callCustomMethodAsync } from '../service/ApiService';

let moduleApi = {};
let moduleName = "time_keeping_raw_current";

moduleApi.create = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetTimeKeepingLog = async data => {
  let api = {
    module: moduleName,
    type: "GetTimeKeepingLog",
    body: data,
    message: {
      success: "hidden",
      error: "Có lỗi xảy ra, vui lòng thử lại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

export default moduleApi;
